import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const httpErrorInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const messageService = inject(MessageService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      let shouldShowMessage = false;

      if (error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = error.error.message;
        shouldShowMessage = true;
      } else {
        // Server-side error
        switch (error.status) {
          case 400:
            errorMessage = wrapHttpErrorMessage(error?.error?.error);
            shouldShowMessage = true;
            break;
          case 401:
            errorMessage = 'Your authentication has expired. Please try refreshing the page manually.';
            shouldShowMessage = true;
            break;
          case 403:
            errorMessage = request.method === 'GET' ? 'You do not have permission to access this resource' : 'You do not have permission to perform this action';
            shouldShowMessage = true;
            break;
          case 404:
            errorMessage = 'Not Found';
            shouldShowMessage = false; // Do not show message for 404, handled by NotFoundComponent
            break;
          default:
            errorMessage = `We're currently experiencing an issue that is preventing you from accessing our service. Our team has been notified and is working to resolve it. Thank you for your patience.`;
            if (error?.error?.error?.data) {
              errorMessage += ` [Request ID: ${error.error.error.data.requestId}]`;
            }
            shouldShowMessage = true;
            break;
        }
      }

      if (shouldShowMessage) {
        messageService.add({ severity: 'error', summary: 'Error', sticky: true, detail: errorMessage || 'Unknown error occurred' });
      }

      return throwError(() => error);
    })
  );
};

function wrapHttpErrorMessage(error: any): string {
  if (!error) {
    return '';
  }

  let errorMessage = error.details ?? error.message;

  return errorMessage;
}
